import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment'
import { Button, Space ,Box, ActionIcon,Affix, Center, Paper, Overlay} from '@mantine/core';
import { IconSquareRoundedX } from '@tabler/icons';

import ContainerTranslation from "../partials/ContainerTranslation";

import { fetchProgram, updateFieldProgram, validate } from '../../actions/program';

import history from '../../history';
import { InputText } from '../input/InputText.tsx';
import { InputDate } from '../input/InputDate';
import { TextAreaLabeled } from '../input/TextAreaLabeled';


var updateTimeout = {}

class FormContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isPopupOpen: false
    }
    this.props.fetchProgram(this.props.match.params.id);
  }


  togglePopup() {
    if (this.state.isPopupOpen) {
      this.setState({ isPopupOpen: false })
    }
    else {
      this.setState({ isPopupOpen: true })
    }
  }


  scrollTop() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (this.props.message === 'Program has been validated') {
      history.push('/program/' + this.props.program._id);
    }

  }


  handleInputChange(obj, isValid, withTimeout) {
    
    var _this = this
    if (withTimeout) {
      clearTimeout(updateTimeout[obj.name]);
      updateTimeout[obj.name] = setTimeout(function () {
        delete updateTimeout[obj.name]
        _this.props.updateFieldProgram(obj, _this.props.match.params.id);
      }, 1000)
    } else {
      _this.props.updateFieldProgram(obj, _this.props.match.params.id);
    }

  }

  handleDateChangeFactory(name,parent,index){
    const _this = this
    function handleChangeDate(date){

      if (date === null || date === undefined){
        return _this.props.updateFieldProgram({name:name,parent:parent,index:index,value:null}, _this.props.match.params.id);
      }
      const parseddate = new Date(date) 
      const formattedDate = parseddate !== "Invalid Date" ? moment(parseddate).format('DD/MM/YYYY') : null

      return _this.props.updateFieldProgram({name:name,parent:parent,index:index,value:formattedDate}, _this.props.match.params.id);
    }
    return handleChangeDate
  }

  string2Date(date){
    return date ? new Date(Date.parse(moment(date, 'DD/MM/YYYY').toISOString())) : null
  }


  handleDocumentValidation(obj){
    var _this = this;
    _this.props.validate(obj,_this.props.program._id);
  }

  handleBlurFactory(parent,index){
    const handleBlur = (e) => {
      this.props.updateFieldProgram({name : e.target.name, value : e.target.value, parent : parent,  index : index}, this.props.match.params.id);
    }
    return handleBlur
  }


  renderValidate() {
    if(!localStorage.user || !this.props.program.authorization.validate){
      return null;
    }

    if(this.props.program.progression !== 100){
      return(
        <Button data-disabled onClick={(event) => event.preventDefault()}>
          Valider le document 
        </Button>
      )
    }

    if(this.props.program.progression === 100 && this.state.isPopupOpen === false){
      return(
        <div className="btn-dashboard"> 
          <button style={{ width: "200px" }} className="primary-btn"   onClick={ () => {this.togglePopup()} } >   
            Valider le document    
          </button>      
        </div>
      )
    }

    if(this.props.program.progression === 100 && this.state.isPopupOpen){
      return(
        <div>
          <>
            <Overlay color="#000" backgroundOpacity={0.85} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }} />
          </>
          <Affix position={{ bottom: (window.innerHeight)/2, left: (window.innerWidth -258.28)/2 }}>
          <div style={{position:"absolute", top:-18,right:-18}}>
              <ActionIcon variant="filled" radius="xl" size="xl" color="red">
              <IconSquareRoundedX onClick={ () => this.togglePopup()} style={{ width: '70%', height: '70%' }} />
              </ActionIcon>
          </div>
          <Box >
            <Paper shadow="md" radius="xl" p="xl">
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <ContainerTranslation id={"nav." + ['Validate context']}/>
              </div>
              <Space h="xs" />
              <Center>
                <div className="btn-dashboard"> 
                  <button style={{ width: "200px" }} className="primary-btn"  onClick={() => { this.handleDocumentValidation(); this.props.history.goBack(); }} >   
                    Valider le document    
                  </button>      
                </div>
              </Center>
            </Paper>
          </Box>
          </Affix>
        </div>
      )
    }
  }



  render() {

    var route = "/program/" + this.props.match.params.id

    var name = "Unknown Form"
    var subname = ""

    if (localStorage.user && JSON.parse(localStorage.user) && JSON.parse(localStorage.user).program && JSON.parse(localStorage.user).program._id === this.props.match.params.id) {
      name = "name";
      subname = "subname";
    } else {
        name = "name";
        subname = "subname";
    }




    if (this.props.program && Object.keys(this.props.program).length === 0) {
      return (
        <h3>Loading...</h3>
      )
    } else {



      return (

        

        <div className="formulaires">
          <div style={{color:"red"}}>*Fonctionnalité en cours de développement</div>
          <div className="formulaires-header">
            <h2>{name}</h2>
            <p style={{ margin: 0, textAlign: 'center' }}>{subname}</p>
            <span className="link-back"><Link to={route}><i className="fas fa-arrow-left" style={{ color: "#E30119", marginRight: "10px" }}></i><ContainerTranslation id={"nav.Back"} /></Link></span>
          </div>


          {/*NEW FORM*/}

          {/*INFORMATIONS*/}
          <div className="formulaire-section">

            <div className="formulaire-header">
              <h2>Form </h2>
              <p className="info">{"The field marked with"}<span>*</span> are required</p>
            </div>

            <div className={"formulaire wide"}>
              <div className={"formulaire-field text"}>
                <InputText
                  onBlur={this.handleBlurFactory('information')}
                  value={this.props.program.content['information']['name']}
                  name={'name'}
                  isRequired={true}
                  label={{title : 'name'}}
                />
              </div>
              <div className={"formulaire-field text"}>
                <div className={"inline"}>
                  <InputDate
                    locale={this.props.translate('content.localisation')}
                    onChange={this.handleDateChangeFactory('start-date','information',null)}
                    value={this.string2Date(this.props.program.content['information']['start-date'])}
                    isRequired={false}
                    label={this.props.translate("content." + ['information'] + "." + ['start-date'] + ".title")}
                  />
                </div>
                <div className={"inline"} style={{ marginLeft: '20px' }}>
                  <InputDate
                    locale={this.props.translate('content.localisation')}
                    onChange={this.handleDateChangeFactory('end-date','information',null)}
                    value={this.string2Date(this.props.program.content['information']['end-date'])}
                    isRequired={false}
                    label={this.props.translate("content." + ['information'] + "." + ['end-date'] + ".title")}
                  />
                </div>
              </div>
            </div>

          </div>



          {/*NOTES*/}
          <div className="formulaire-section">

            <div className="formulaire-header">
              <ContainerTranslation id={"content." + ['notes'] + ".title"} tag="h2" />
              <p className="info">{"The field marked with"}<span>*</span> are required</p>
            </div>

            <div className={"formulaire wide"}>
              <div className={"formulaire-field textarea"}>
                <TextAreaLabeled
                  onBlur={this.handleBlurFactory('notes')}
                  name={'description'}
                  value={this.props.program.content['notes']['description']}
                  isRequired={true}
                  label={{title :'description'}}
                  placeholder={""}
                  maxLength={2600}
                  height={'560px'}
                />
              </div>
            </div>

          </div>

          {/*END NEW FORM*/}

          <div className="btn-dashboard">
            <p>{this.props.program.progression ? this.props.program.progression : 0}<ContainerTranslation id={"nav." + ['completed']} /></p>
            <div>
              <Link to={route}><button className="primary-btn"><ContainerTranslation id={"nav." + ['Back to the dashboard']} /></button></Link>
            </div>
            <div className="renderValidate" >
                {/* {this.renderValidate()} */}
            </div>
          </div>




          <div className="scrollTop" onClick={this.scrollTop.bind(this)}>
            <i className="fas fa-arrow-up" style={{ color: "#E30119" }}></i>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  program: state.program.program,
  message: state.program.message
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchProgram, updateFieldProgram, validate
}, dispatch); 

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(FormContainer)));
